module.exports = __webpack_public_path__ + "images/Card1e8b7000b41f4667ce96902607a7ca2a6.png";